import useSWR from 'swr';

export const useUserPayments = () => {
  const { data, error, isLoading, mutate } = useSWR('/users/user/payments');

  return {
    payments: data?.payments || [],
    error,
    isLoading,
    mutate,
  };
};
